// Compartir: Web Share API donde exista (móvil), copiar enlace como alternativa.

const feedback = (btn, text) => {
  const original = btn.dataset.label || (btn.dataset.label = btn.textContent)
  btn.textContent = text
  btn.classList.add("done")
  setTimeout(() => {
    btn.textContent = original
    btn.classList.remove("done")
  }, 1800)
}

const copy = async (btn, url) => {
  try {
    await navigator.clipboard.writeText(url)
    feedback(btn, "Copiado")
  } catch {
    window.prompt("Copia el enlace:", url)
  }
}

document.querySelectorAll("[data-share]").forEach((btn) => {
  const { title, text, url } = btn.dataset
  if (!navigator.share) {
    // Sin Web Share (escritorio) se oculta: al lado están los botones de copiar
    btn.hidden = true
    return
  }
  btn.addEventListener("click", async () => {
    try {
      await navigator.share({ title, text, url })
    } catch {
      /* cancelado por el usuario */
    }
  })
})

document.querySelectorAll("[data-copy]").forEach((btn) => {
  btn.addEventListener("click", () => copy(btn, btn.dataset.copy))
})

// Botón «Compartir» de la home: en táctil abre la hoja nativa; en escritorio, un panel anclado
// con copiar enlace, descargar tarjeta y más formatos. Safari de Mac también tiene navigator.share,
// de ahí la comprobación de puntero.
const tactil = window.matchMedia("(pointer: coarse)").matches

const cerrarPaneles = (salvo) => {
  document.querySelectorAll(".share-pop:not([hidden])").forEach((pop) => {
    if (pop === salvo) return
    pop.hidden = true
    pop.previousElementSibling.setAttribute("aria-expanded", "false")
  })
}

document.querySelectorAll("[data-share-menu]").forEach((btn) => {
  const { title, text, url } = btn.dataset
  const pop = btn.nextElementSibling
  btn.addEventListener("click", async (ev) => {
    ev.stopPropagation()
    if (navigator.share && tactil) {
      try {
        await navigator.share({ title, text, url })
      } catch {
        /* cancelado */
      }
      return
    }
    const abrir = pop.hidden
    cerrarPaneles(pop)
    pop.hidden = !abrir
    btn.setAttribute("aria-expanded", String(abrir))
  })
  pop.addEventListener("click", (ev) => ev.stopPropagation())
})

document.addEventListener("click", () => cerrarPaneles())
document.addEventListener("keydown", (ev) => {
  if (ev.key === "Escape") cerrarPaneles()
})
